var colorOptions = [
    {
        val: 'WHITE',
        label: '白色',
    },
    {
        val: 'BLACK',
        label: '黑色',
    },
    {
        val: 'DARKGREY',
        label: '深灰色',
    },
    {
        val: 'LIGHTGRAY',
        label: '银灰色',
    },
    {
        val: 'ORANGE',
        label: '橙色',
    },
    {
        val: 'GREEN',
        label: '绿色',
    },
    {
        val: 'BLUE',
        label: '蓝色',
    },
    {
        val: 'RED',
        label: '红色',
    },
    {
        val: 'PURPLE',
        label: '紫色',
    },
    {
        val: 'CHAMPAGNE',
        label: '香槟色',
    },
    {
        val: 'YELLOW',
        label: '黄色',
    },
    {
        val: 'OTHER',
        label: '其他',
    },
];
var contractStatusOptions = [
    {
        val: 'NONE',
        label: '无合同',
    },
    {
        val: 'INACTIVE',
        label: '合同未开始',
    },
    {
        val: 'ACTIVE',
        label: '合同进行中',
    },
    {
        val: 'TERMINATED',
        label: '合同已结束',
    },
];
var vehicleStatusOptions = [
    {
        label: '已签约',
        val: 'SIGNED',
    },
    {
        label: '在库未签约',
        val: 'INVENTORY',
    },
    {
        label: '已处置',
        val: 'DISPOSED',
    },
];
var driverClassifyOptions = [
    {
        label: '自营',
        val: 'SELFSUPPORT',
    },
    {
        label: '签约',
        val: 'SIGNED',
    },
    {
        label: '加盟',
        val: 'JOIN',
    },
];
var purposeOptions = [
    {
        val: 'JINGZU',
        label: '经租',
    },
    {
        val: 'RONGZU',
        label: '融租',
    },
    {
        val: 'OTHER',
        label: '其他',
    },
]; // 车辆用途
var poweredOptions = [
    {
        val: 'OIL',
        label: '油车',
    },
    {
        val: 'ELECTRIC',
        label: '新能源',
    },
    {
        val: 'HYBRID',
        label: '油电混合',
    },
];
var leaseMode = {
    JINGZU: '经租',
    RONGZU: '融租',
};
var contractStatusName = {
    // 合同状态
    NONE: '无合同',
    INACTIVE: '合同未开始',
    ACTIVE: '合同进行中',
    TERMINATED: '合同已结束',
};
var contractBoardName = {
    // 合同状态
    NONE: '无合同',
    INACTIVE: '未开始',
    ACTIVE: '进行中',
    TERMINATED: '已结束',
};
var purposeName = {
    JINGZU: '经租',
    RONGZU: '融租',
    OTHER: '其他',
};
var runMode = {
    SINGLE: '单班',
    DOUBLE: '双班',
};
var cooperationMode = {
    SELF: '自营',
    JOINT: '合资',
};
var signStatus = {
    UNSEND: '未发送',
    UNSIGN: '未签署',
    SIGNED: '已签署',
};
var vehicleStatusName = {
    SIGNED: '已签约',
    INVENTORY: '在库未签约',
    DISPOSED: '已处置',
};
var poweredName = {
    OIL: '油车',
    ELECTRIC: '新能源',
    HYBRID: '油电混合',
};
var colorName = {
    WHITE: '白色',
    BLACK: '黑色',
    DARKGREY: '深灰色',
    LIGHTGRAY: '银灰色',
    ORANGE: '橙色',
    GREEN: '绿色',
    RED: '红色',
    BLUE: '蓝色',
    PURPLE: '紫色',
    CHAMPAGNE: '香槟色',
    YELLOW: '黄色',
    OTHER: '其他',
};
var transType = {
    RENT: {
        name: '租金入账',
        isHasSec: true,
        identity: 'income',
    },
    CHARGE: {
        name: '收费入账',
        isHasSec: true,
        identity: 'income',
    },
    DRIVER_AWARD: {
        name: '司机补款奖励',
        isHasSec: true,
        identity: 'pay',
    },
    WITHDRAW: {
        name: '提现',
        isHasSec: true,
        identity: 'pay',
    },
    TRANSFER_OUT: {
        name: '转账支出',
        isHasSec: false,
        identity: 'pay',
    },
    TRANSFER_CREDIT: {
        name: '转账入账',
        isHasSec: false,
        identity: 'income',
    },
    ACTIVE_REPAY_FEE: {
        name: '主动还款手续费',
        isHasSec: false,
        identity: 'pay',
    },
    TRAFFIC_VIOLATION_QUERY_FEE: {
        name: '违章查询费',
        isHasSec: false,
        identity: 'pay',
    },
    CP_RENT_DEDUCT: {
        name: '资方还款',
        isHasSec: false,
        identity: 'pay',
    },
};
var transSubType = {
    DAY_AVERAGE: '日扣平均',
    DAY_GREED: '日扣优先',
    ACTIVE: '主动还款',
    AWARD: '奖励',
    SUBSIDY: '补贴',
    REFUND: '退款',
    TRAFFIC_FINE: '违章罚款',
    INSURE: '保险',
    DEPOSIT: '押金',
    MANAGE_FEE: '管理费',
    OTHER_REPAY: '其他还款',
    WITHDRAW_FEE: '提现手续费',
    WITHDRAW_ARRIVAL: '提现到账金额',
};
var rewardStatus = {
    SUCCESS: '成功',
    FAIL: '失败',
    HANDLING: '处理中',
};
export { colorOptions, leaseMode, poweredOptions, purposeOptions, colorName, poweredName, vehicleStatusName, purposeName, contractStatusName, contractStatusOptions, vehicleStatusOptions, driverClassifyOptions, contractBoardName, transType, transSubType, rewardStatus, runMode, cooperationMode, signStatus, };
